function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDostawaDpd = function SvgDostawaDpd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50mm",
    height: "21mm",
    viewBox: "0 0 50 21"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f3f42",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M32.173 16.573c-.91.254-2.095.36-3.111.36-2.646 0-4.382-1.376-4.382-3.894 0-2.392 1.63-3.937 4-3.937.53 0 1.101.063 1.44.232v-3.47h2.053zm-2.053-5.46c-.318-.149-.762-.233-1.27-.233-1.249 0-2.074.762-2.074 2.095 0 1.418.889 2.223 2.35 2.223.253 0 .655 0 .994-.085zm18.923 5.46c-.91.254-2.096.36-3.133.36-2.624 0-4.381-1.376-4.381-3.894 0-2.392 1.63-3.937 4-3.937.55 0 1.1.063 1.44.232v-3.47h2.074zm-2.074-5.46c-.318-.149-.741-.233-1.25-.233-1.27 0-2.095.762-2.095 2.095 0 1.418.91 2.223 2.37 2.223.255 0 .636 0 .975-.085zm-11.557 0c.338-.149.825-.191 1.227-.191 1.27 0 2.138.72 2.138 2.01 0 1.525-.974 2.223-2.265 2.244v1.757h.106c2.667 0 4.255-1.46 4.255-4.064 0-2.37-1.694-3.767-4.191-3.767-1.27 0-2.52.296-3.345.635V19.79h2.075zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M17.61 4.487h.022-.021zM17.103 4.212l.338.381.19-.106-.528-.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m16.595 3.937.656.762.233-.127-.254-.296-.635-.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m16.065 3.662.995 1.143.233-.127L16.722 4l-.657-.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M15.557 3.387 16.87 4.91l.233-.127-.91-1.059-.636-.338zm2.52 2.688-.149.084.148.17v-.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m15.05 3.111 1.63 1.905.232-.127-1.228-1.439-.635-.339zm2.942 3.006-.233.148.317.381v-.402l-.084-.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m14.52 2.836 1.969 2.286.254-.127-1.567-1.82-.656-.339zm3.281 3.387-.233.148.508.593v-.402l-.275-.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m14.012 2.561 2.307 2.667.233-.127L14.647 2.9l-.635-.339zm3.599 3.789-.233.127.698.825V6.9l-.465-.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m13.504 2.286 2.625 3.048.233-.127-2.223-2.582-.635-.339zm3.916 4.17-.233.127.89 1.037v-.402l-.657-.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m12.975 2.01 2.963 3.43.233-.127-2.54-2.964-.656-.338zm4.255 4.552-.233.127 1.08 1.248v-.402l-.847-.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m12.467 1.736 3.28 3.83.234-.147-2.879-3.345-.635-.338zm4.572 4.931-.233.127 1.27 1.482v-.402L17.04 6.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m11.938 1.46 3.62 4.213.232-.149L12.594 1.8l-.656-.339Zm4.932 5.313-.254.127 1.46 1.694V8.19L16.87 6.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m11.43 1.185 3.937 4.593.254-.148-3.535-4.106-.656-.339Zm5.25 5.694-.234.127 1.63 1.926V8.51l-1.397-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m10.922.91 4.276 4.974.232-.148-3.873-4.487-.635-.339zm5.567 6.075-.233.127 1.82 2.138v-.402L16.49 6.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m10.393.614 4.614 5.376.233-.148L11.049.974l-.656-.36Zm5.905 6.477-.233.127 2.011 2.35v-.403l-1.778-2.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m9.885.339 4.932 5.757.232-.127-4.508-5.27-.656-.36Zm6.223 6.858-.233.127 2.201 2.582v-.423l-1.968-2.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m9.377.085 5.25 6.117.232-.127L10.012.423 9.377.085zm6.54 7.217-.233.127 2.392 2.794v-.402l-2.159-2.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m9.038 0 5.398 6.308.232-.127L9.504.148 9.377.085A.621.621 0 0 0 9.038 0Zm6.689 7.408-.233.127 2.582 3.006v-.402l-2.35-2.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M9.038 0c-.085 0-.17.021-.254.042l5.461 6.371.254-.127L9.102 0h-.064zm6.52 7.514-.233.127 2.751 3.239v-.424l-2.519-2.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M8.848.021c-.043.021-.106.042-.127.064l-.127.063 5.482 6.371.233-.127L8.848.022zm6.519 7.599-.233.148 2.942 3.43v-.403l-2.71-3.175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m8.636.106-.233.127 5.482 6.392.233-.127L8.636.106zm6.54 7.62-.232.148 3.132 3.64v-.402l-2.9-3.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m8.445.212-.232.127 5.482 6.392.233-.127L8.445.212zm6.54 7.62-.232.148 3.323 3.873v-.402l-3.09-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m8.255.317-.233.127 5.482 6.393.233-.127L8.255.317zm6.54 7.62-.232.149 3.513 4.085v-.402l-3.28-3.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M8.064.423 7.832.55l5.482 6.393.233-.127L8.064.423zm6.54 7.62-.232.148 3.704 4.297v-.402l-3.471-4.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M7.874.53 7.64.655l5.482 6.392.233-.127L7.874.53zm6.562 7.62-.233.147 3.873 4.53v-.402l-3.64-4.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m7.683.614-.232.148 5.503 6.392.233-.127L7.683.614zm6.562 7.662-.233.127 4.064 4.741v-.402l-3.83-4.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M7.493.72 7.26.847l5.503 6.413.233-.127L7.493.72zm6.562 7.662-.233.127 4.254 4.974v-.423l-4.021-4.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M7.302.825 7.07.952l5.503 6.435.233-.148L7.302.825Zm6.562 7.663-.233.127 4.445 5.186v-.403l-4.212-4.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m7.112.931-.233.127 5.503 6.435.233-.148L7.112.93Zm6.562 7.663-.233.127 4.635 5.397v-.402l-4.402-5.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m6.921 1.037-.232.127L12.192 7.6l.233-.148L6.92 1.037zM13.483 8.7l-.233.127 4.826 5.63v-.423L13.483 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m6.73 1.143-.232.127 5.503 6.435.233-.149-5.503-6.413zm6.584 7.662-.233.127 4.995 5.842v-.402l-4.762-5.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m6.54 1.228-.254.127 5.546 6.455.233-.148L6.54 1.228zm6.583 7.683-.233.127 5.186 6.054v-.402L13.123 8.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m6.35 1.333-.254.127 5.567 6.477a.165.165 0 0 1 .084-.084l.127-.085L6.35 1.333zm6.583 7.684-.233.127 5.334 6.223a.618.618 0 0 0 .042-.19v-.17l-5.143-5.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m6.16 1.44-.255.126L11.6 8.191v-.084c0-.064.043-.148.085-.212L6.159 1.44Zm6.582 7.683-.17.106c-.02 0-.041.02-.063.02l5.419 6.33a.715.715 0 0 0 .127-.254l-5.313-6.202Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m5.969 1.545-.254.127 5.884 6.858v-.423L5.97 1.545zm6.18 7.599 5.63 6.583c.064-.043.128-.127.191-.19l-5.418-6.308a.362.362 0 0 1-.297 0l-.105-.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m5.778 1.651-.254.127L17.59 15.833l.17-.085.063-.064-5.545-6.455h-.022l-.486-.297c-.043-.02-.064-.063-.106-.106-.043-.063-.043-.105-.064-.148v-.233L5.78 1.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m5.588 1.757-.254.127 12.065 14.054.233-.127L5.588 1.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m5.397 1.841-.254.127L17.23 16.044l.232-.127L5.397 1.841Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m5.207 1.947-.254.127L17.039 16.15l.233-.127L5.207 1.947Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m5.016 2.053-.254.127L16.85 16.256l.232-.127L5.016 2.053Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m4.805 2.159-.233.127 12.086 14.097.233-.148L4.805 2.159Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m4.614 2.265-.233.127 12.087 14.097.232-.148L4.614 2.265Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m4.424 2.37-.233.128 12.107 14.097.233-.149L4.424 2.371Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M4.233 2.455 4 2.582 16.108 16.7l.233-.148L4.233 2.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m4.043 2.561-.233.127 12.107 14.118.233-.127L4.043 2.561Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m3.852 2.667-.233.127 5.885 6.858.19.127c.085.042.17.148.17.254v.021l5.863 6.858.233-.127L3.852 2.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m3.662 2.773-.233.127 5.524 6.456.699.38-5.99-6.963Zm6.18 7.196c0 .022.022.043.022.064v.36l5.672 6.625.233-.127-5.927-6.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m3.471 2.879-.233.127 5.165 6.032.699.381-5.63-6.54zm6.393 7.43v.401l5.503 6.414.233-.127-5.736-6.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m3.28 2.984-.232.127 4.826 5.61.677.38-5.27-6.117zm6.584 7.642v.423l5.312 6.18.233-.126-5.545-6.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m3.09 3.07-.233.126 4.467 5.207.677.402L3.09 3.07Zm6.774 7.894v.402l5.122 5.97.233-.128-5.355-6.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m2.9 3.175-.233.127 4.106 4.784.678.402L2.9 3.175zm6.964 8.107v.402l4.931 5.757.233-.127-5.164-6.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m2.71 3.28-.234.128 3.747 4.381.677.381-4.19-4.89Zm7.154 8.32v.423l4.74 5.545.234-.148-4.974-5.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m2.519 3.387-.233.127 3.387 3.958.677.38-3.831-4.465zm7.345 8.55v.403l4.572 5.334.232-.148-4.804-5.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m2.328 3.492-.233.127 3.027 3.535.699.381-3.493-4.043zm7.536 8.763v.403l4.381 5.122.233-.148-4.614-5.377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m2.138 3.598-.233.127 2.667 3.112.698.402-3.132-3.64zm5.545 6.858.55.635v-.233c0-.042-.042-.105-.084-.127l-.466-.275Zm2.18 2.117v.423l4.192 4.89.232-.148-4.423-5.165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m1.947 3.683-.233.127 2.308 2.71.698.401-2.773-3.238zm5.186 6.456 1.1 1.27v-.402l-.401-.466-.699-.402zm2.73 2.773v.402l4.001 4.678.233-.127-4.233-4.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m1.757 3.789-.233.127 1.968 2.307.678.38L1.757 3.79zm4.826 6.053 1.65 1.905v-.402l-.952-1.122-.698-.38zm3.28 3.387v.402l3.81 4.466.233-.127-4.042-4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m1.566 3.895-.233.127 1.61 1.883.676.381-2.053-2.391zm4.488 5.63 2.18 2.54v-.402L6.73 9.906l-.677-.381Zm3.81 4.043v.402l3.64 4.233.233-.127-3.873-4.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m1.376 4-.233.127 1.249 1.461.677.38L1.376 4zm4.127 5.207 2.73 3.175v-.402L6.182 9.61l-.678-.403Zm4.36 4.678v.402l3.45 4.022.234-.127-3.683-4.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m1.185 4.106-.233.127.89 1.037.677.403-1.334-1.567ZM4.953 8.89l3.28 3.831v-.402L5.63 9.292l-.677-.402Zm4.91 5.313v.402l3.26 3.81.233-.127-3.492-4.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m.995 4.212-.233.127.53.614.698.402-.995-1.143zm3.408 4.382 3.83 4.445v-.403L5.08 8.975l-.677-.381zm5.46 5.947v.403l3.07 3.577.233-.127-3.302-3.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m.804 4.297-.254.127.19.233.7.38-.636-.74zm3.048 3.98 4.382 5.1v-.423L4.55 8.657l-.699-.38zm6.012 6.582v.402l2.878 3.387.233-.148-3.111-3.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m.614 4.403-.148.084.423.233-.275-.317zm2.688 3.556 4.932 5.736v-.402L4 8.36l-.698-.402zm6.562 7.217v.424l2.709 3.154.233-.149-2.942-3.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m2.773 7.641 5.46 6.371v-.402L3.45 8.043l-.677-.402Zm7.09 7.874v.402l2.52 2.942.232-.148-2.751-3.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m2.222 7.345 6.012 7.006v-.423L2.9 7.726l-.678-.381zm7.642 8.488v.402l2.328 2.73.233-.148-2.561-2.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#dc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m1.672 7.027 6.562 7.641v-.402L2.349 7.408l-.677-.38zm8.192 9.123v.423L12 19.071l.233-.127-2.37-2.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#db0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m1.122 6.71 7.112 8.276v-.402L1.799 7.112l-.677-.402Zm8.742 9.779v.402l1.947 2.286.233-.127-2.18-2.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#da0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m.571 6.392 7.663 8.933v-.403L1.249 6.794.57 6.392Zm9.293 10.414v.402l1.778 2.075.232-.127-2.01-2.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d90032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "m.021 6.096 8.213 9.546v-.402L.72 6.477.02 6.096zm9.843 11.028v.423l1.587 1.842.233-.127-1.82-2.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 6.075v.296l8.234 9.589v-.403L.169 6.16 0 6.075Zm9.864 11.387v.254a.162.162 0 0 1-.043.106l1.44 1.672.232-.127-1.63-1.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d70032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 6.286v.424l8.234 9.588v-.402L0 6.286ZM9.842 17.78c-.02.085-.084.17-.148.19l-.02.022L11.07 19.6l.233-.127-1.46-1.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d60032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 6.625v.402l8.234 9.589v-.402L0 6.625ZM9.715 17.95c0 .021 0 .021-.02.021l-.212.127 1.397 1.609.232-.127-1.397-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d50032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 6.943v.402l8.234 9.588v-.402L0 6.943Zm9.546 11.112-.254.148 1.418 1.63.233-.148-1.397-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d40032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 7.281v.402l8.234 9.589v-.402L0 7.28Zm9.356 10.88-.149.085c-.042.02-.084.02-.127.02l1.44 1.673.233-.148-1.397-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d30032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 7.599V8l8.234 9.588v-.402L0 7.6ZM8.7 18.16l1.63 1.884.232-.148-1.418-1.63c-.021 0-.064.02-.085.02h-.02c-.064 0-.107-.02-.15-.041l-.19-.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d20032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 7.916v.424l10.139 11.81.233-.148-1.524-1.778-.466-.254a.294.294 0 0 1-.148-.254v-.211L0 7.916Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d10032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 8.255v.402l9.948 11.6.233-.128L0 8.255Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d00032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 8.572v.403l9.758 11.387.233-.127L0 8.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cf0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 8.89v.423l9.588 11.155.233-.127L0 8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ce0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 9.229v.402l9.398 10.943.233-.127L0 9.229Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cd0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 9.546v.402l9.186 10.71c.064-.02.127-.042.19-.063l.064-.042L0 9.546Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 9.864v.423l8.911 10.372h.127c.064 0 .127 0 .19-.022L0 9.864Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 10.202v.402l8.424 9.822.297.169c.063.042.169.064.254.064L0 10.202Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ca0032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 10.52v.402l7.874 9.186.698.402L0 10.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c90032",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 10.858v.403l7.324 8.53.698.402L0 10.858Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c80033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 11.176v.402l6.773 7.895.678.402L0 11.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c70033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 11.493v.403l6.223 7.26.677.402L0 11.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c60033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 11.832v.402l5.651 6.583.699.402L0 11.832Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c50033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 12.15v.402L5.101 18.5l.699.402L0 12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c40033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 12.467v.402l4.55 5.313.7.402L0 12.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c30033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 12.806v.402l4 4.657.699.402L0 12.806Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c20033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 13.123v.402l3.45 4.022.699.402L0 13.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c10033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 13.44v.424l2.9 3.366.677.402L0 13.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c00033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 13.78v.402l2.328 2.73.699.402L0 13.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf0033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 14.097v.402l1.778 2.096.698.38L0 14.098Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#be0033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 14.414v.424l1.228 1.418.698.402L0 14.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd0033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 14.753v.402l.677.783.699.403L0 14.753Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bc0033",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M0 15.07v.106c0 .212.148.466.317.572l.508.275L0 15.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b03",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    d: "M.127 15.557c.042.043.063.085.106.106l-.106-.106Z"
  }));
};
export default SvgDostawaDpd;